import * as React from 'react';
import { useAppDispatch } from './useAppDispatch';
import { setPageSource } from '../slices';

const SOURCE_KEY = 'my_home_source';

export const useSaveSource = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (window) {
      const url = new URL(window.location.href);

      const source = url.searchParams.get('from');

      if (source) {
        dispatch(setPageSource(source));

        localStorage.setItem(SOURCE_KEY, source);
      } else {
        const localSource = localStorage.getItem(SOURCE_KEY);

        if (localSource) {
          dispatch(setPageSource(localSource));
        }
      }
    }
  }, []);
};
